// Formatação de exibição do chat (pt-BR). CommonJS (ver utils/messages.js).

const pad = value => String(value).padStart(2, '0')

const toDate = value => {
  if (!value) return null
  const date = new Date(value)
  return Number.isNaN(date.getTime()) ? null : date
}

const isSameDay = (a, b) => a.getFullYear() === b.getFullYear()
  && a.getMonth() === b.getMonth()
  && a.getDate() === b.getDate()

const formatTime = value => {
  const date = toDate(value)
  return date ? `${pad(date.getHours())}:${pad(date.getMinutes())}` : ''
}

// Inbox: hoje → "14:05"; outro dia → "03/10".
const formatInboxDate = (value, now = new Date()) => {
  const date = toDate(value)
  if (!date) return ''
  if (isSameDay(date, now)) return formatTime(date)
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}`
}

const formatDateTime = value => {
  const date = toDate(value)
  if (!date) return ''
  return `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()} ${formatTime(date)}`
}

const initials = name => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean)
  if (!parts.length) return '?'
  const first = parts[0][0]
  const last = parts.length > 1 ? parts[parts.length - 1][0] : ''
  return `${first}${last}`.toUpperCase()
}

module.exports = {
  formatTime,
  formatInboxDate,
  formatDateTime,
  initials,
}
